import { createAsyncThunk } from '@reduxjs/toolkit';
import { addLoading, removeLoading } from '../appAction';
import { axios } from '@utils/lib';
import { Enums, Paths } from '@utils/constants';

export const getSettingAsync = createAsyncThunk(
  'api/getSettingAsync',
  async (_, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    try {
      const result = await axios.request<ISettingRes>(
        Enums.HTTP_METHOD.GET,
        Paths.SETTING
      );
      return result.data;
    } catch (error) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  }
);

export const changeSettingAsync = createAsyncThunk(
  'api/changSettingAsync',
  async (params: ISettingBase[], { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    try {
      const result = await axios.request<ISettingData>(
        Enums.HTTP_METHOD.PUT,
        Paths.SETTING,
        {
          settings: params,
        }
      );
      return result.data;
    } catch (error) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  }
);

export const getSettingFindByKeyAsync = createAsyncThunk(
  'api/getSettingFindByKeyAsync',
  async (_, { rejectWithValue, dispatch }) => {
    dispatch(addLoading());
    try {
      const result = await axios.request<ISettingData>(
        Enums.HTTP_METHOD.GET,
        Paths.SETTING_FIND_BY_KEY.replace(':key', 'FINAL_APPROVAL_ON')
      );
      return result.data;
    } catch (error) {
      return rejectWithValue(error);
    } finally {
      dispatch(removeLoading());
    }
  }
);
